export default "__VITE_ASSET__CtX1uKCe__"